import { defineMessages } from 'react-intl';

export default defineMessages({
    nextDescription: {
        id: 'rewrite.common.views.ml-verbal-authorization.We\'ll review additional required forms next  ',
        defaultMessage: 'We\'ll review additional <strong>required forms</strong> next'
    }
});